import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import LoadingContent from 'src/components/atoms/loading-content'

import { useMenuStore } from 'src/stores'

type LoadingOverlayParams = {
  open: boolean
  showMessages?: boolean
}

const LoadingOverlay = ({
  open,
  showMessages = false,
}: LoadingOverlayParams) => {
  const { collapsed } = useMenuStore()
  const [messageIndex, setMessageIndex] = useState(0)
  const [isTransitioning, setIsTransitioning] = useState(false)
  const { t } = useTranslation()

  const messages = [
    t('loading.messages.wait-moment'),
    t('loading.messages.organizing-information'),
    t('loading.messages.almost-there'),
  ]

  useEffect(() => {
    const interval = setInterval(() => {
      setIsTransitioning(true)

      setTimeout(() => {
        setMessageIndex((prev) => (prev + 1) % messages.length)
        setIsTransitioning(false)
      }, 200)
    }, 3000)

    return () => clearInterval(interval)
  })

  return (
    <div
      className={`fixed inset-0 ${open ? 'flex' : 'hidden'} z-[2000] items-center justify-center bg-[rgb(109_109_109/0.2)] backdrop-blur-sm ${collapsed ? 'pl-0' : 'pl-[200px]'}`}
    >
      <LoadingContent
        message={showMessages ? messages[messageIndex] : undefined}
        isTransitioning={showMessages ? isTransitioning : false}
      />
    </div>
  )
}

export default LoadingOverlay
